import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <Helmet>
        <title>Terms of Service | WA BHA Treatment Finder</title>
        <meta name="description" content="Terms of Service and No Refund Policy for WA BHA Treatment Finder." />
      </Helmet>
      <div className="max-w-3xl mx-auto">

        {/* Back link */}
        <Link to="/" className="text-sm text-blue-600 hover:underline mb-6 inline-block">
          ← Back to search
        </Link>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 space-y-10">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-1">Terms of Service &amp; Policies</h1>
            <p className="text-sm text-gray-400">Last updated: February 2026</p>
          </div>

          {/* ── Terms of Service ── */}
          <section>
            <h2 className="text-lg font-semibold text-gray-800 border-b border-gray-100 pb-2 mb-4">
              Terms of Service
            </h2>
            <div className="text-gray-600 text-sm leading-relaxed space-y-3">
              <p>
                <strong>1. Acceptance of Terms.</strong> By creating an account or using BHA Finder,
                you agree to these terms.
              </p>
              <p>
                <strong>2. Service Description.</strong> BHA Finder provides a searchable database of
                Behavioral Health Agencies. We strive for accuracy but do not guarantee that all agency
                data is up-to-date at all times.
              </p>
              <p>
                <strong>3. User Conduct.</strong> You agree not to use automated "bots" or "scrapers"
                to download our database. This service is for individual or professional use only.
              </p>
              <p>
                <strong>4. Payments.</strong> Subscriptions are billed in advance. You may cancel at
                any time, but access will continue until the end of your current billing cycle.
              </p>
              <p>
                <strong>5. Limitation of Liability.</strong> BHA Finder is a data tool. We are not
                responsible for clinical decisions or placements made based on the information provided
                in our app.
              </p>
            </div>
          </section>

          {/* ── Refund & Cancellation Policy ── */}
          <section>
            <h2 className="text-lg font-semibold text-gray-800 border-b border-gray-100 pb-2 mb-4">
              Refund &amp; Cancellation Policy
            </h2>
            <div className="text-gray-600 text-sm leading-relaxed space-y-3">
              <p>
                <strong>Cancellations.</strong> You can cancel your subscription at any time through
                your account settings.
              </p>
              <p>
                <strong>Refunds.</strong> Due to the digital nature of our data, we generally do not
                offer refunds once a billing cycle has begun. However, if you experience a technical
                issue that prevents you from using the tool, please contact us at{' '}
                <a href="mailto:watreatmentfinder@gmail.com" className="text-blue-600 hover:underline">
                  watreatmentfinder@gmail.com
                </a>{' '}
                within 7 days and we will review your case for a pro-rated refund or credit.
              </p>
            </div>
          </section>

          {/* ── Privacy Policy ── */}
          <section>
            <h2 className="text-lg font-semibold text-gray-800 border-b border-gray-100 pb-2 mb-4">
              Privacy Policy
            </h2>
            <div className="text-gray-600 text-sm leading-relaxed space-y-3">
              <p>
                <strong>1. Data We Collect.</strong> We collect your email address and name to create
                your account.
              </p>
              <p>
                <strong>2. Payment Security.</strong> We do not store credit card information. All
                payments are processed securely by Stripe.
              </p>
              <p>
                <strong>3. Data Usage.</strong> We do not sell your personal information to third
                parties. We use your data only to manage your account and improve the BHA Finder tool.
              </p>
              <p>
                <strong>4. Cookies.</strong> We use basic cookies to keep you logged into your session.
              </p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}
